import GlobalStyles from '@mui/joy/GlobalStyles'
import Sheet from '@mui/joy/Sheet'
import { Menu } from 'lucide-react'
import { useMobileNav } from 'contexts/MobileNavContext'

export default function Header() {
    const { openMobileNav } = useMobileNav()
    return (
        <Sheet
            sx={{
                display: { xs: 'flex', md: 'none' },
                alignItems: 'center',
                justifyContent: 'flex-start',
                position: 'fixed',
                top: 0,
                width: '100vw',
                height: 'var(--Header-height)',
                zIndex: 9995,
                px: 1.5,
                gap: 1,
                borderBottom: '1px solid',
                borderColor: 'background.level1',
                boxShadow: 'sm',
            }}
        >
            <GlobalStyles
                styles={(theme) => ({
                    ':root': {
                        '--Header-height': '52px',
                        [theme.breakpoints.up('md')]: {
                            '--Header-height': '0px',
                        },
                    },
                })}
            />
            {/* Opens the navigation drawer (MasterLayout owns the state). */}
            <button
                type="button"
                onClick={openMobileNav}
                aria-label="Open navigation menu"
                className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
            >
                <Menu className="h-6 w-6" />
            </button>
        </Sheet>
    )
}
